export enum FundingMethod {
    na = 0,
    undefined = 1,
    none = 2,
    lumpsum = 3,
    recurring = 4,
    both = 5,
}
